import { Stack, Typography } from "@mui/material";

export default function Design() {
  return (
    <Stack spacing={8} p={8}>
      <Stack py={8} alignItems="center" spacing={3}>
        <Typography color="#E94F37" variant="h3" fontWeight="bold">
          Onze ontwerpopgave
        </Typography>

        <Typography width={700} fontSize="18px" textAlign="center" color="#888">
          We hebben, op basis van ons brononderzoek, onze ontwerpopgave gespecificeerd tot de eerste
          fase van crisisbestrijding: preventie. Daarbij richten we ons op bewoners van
          studentenhuizen in regio Rotterdam-Rijnmond.
        </Typography>
      </Stack>

      <Stack spacing={10} direction="row">
        <img
          src={require("../Assets/Images/research.webp")}
          alt="research"
          style={{ width: "50%" }}
        />

        <Stack spacing={3}>
          <Typography color="#E94F37" variant="h3" fontWeight="bold">
            Onderzoek
          </Typography>

          <Typography width={350} fontSize="18px" color="#888">
            We hebben ons geörienteerd binnen de ontwerpcontext met deskresearch. Op basis van de
            uitkomsten daarvan kozen we onze doelgroep: bewoners van studentenhuizen. Ter verdieping
            voerden we verder brononderzoek en fieldresearch (enquête en interviews) uit om de
            pijnpunten van onze doelgroep te ontdekken.
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
